/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_DiscardInputs */

const en_us2_coach_mic_discard = /** @type {(inputs: Coach_Mic_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard recording`)
};

const pt_br2_coach_mic_discard = /** @type {(inputs: Coach_Mic_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar áudio`)
};

const es_419_coach_mic_discard = /** @type {(inputs: Coach_Mic_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar audio`)
};

const pt_pt2_coach_mic_discard = /** @type {(inputs: Coach_Mic_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar áudio`)
};

const fr_fr2_coach_mic_discard = /** @type {(inputs: Coach_Mic_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer l'enregistrement`)
};

const de_de2_coach_mic_discard = /** @type {(inputs: Coach_Mic_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnahme verwerfen`)
};

const it_it2_coach_mic_discard = /** @type {(inputs: Coach_Mic_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarta registrazione`)
};

/**
* | output |
* | --- |
* | "Discard recording" |
*
* @param {Coach_Mic_DiscardInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_discard = /** @type {((inputs?: Coach_Mic_DiscardInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_DiscardInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_discard(inputs)
	if (locale === "es-419") return es_419_coach_mic_discard(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_discard(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_discard(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_discard(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_discard(inputs)
	return en_us2_coach_mic_discard(inputs)
});
export { coach_mic_discard as "coach-mic.discard" }